import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import defaultAttributes from "backend/defaultAttributes";
import { usePeriod } from "backend/model/usePeriod";
import { getElement } from "backend/model/getElement";
import getValues from "backend/values";
import { resultSort } from "init/sort";

import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";
import isDraftFilterAtLocation from "@qpr/client-api-base/attributes/drafts/disabledPages";

const useElements = (id?: string[]) => {
  const ctx = useAppContext();
  const periods = usePeriod();
  const { data: periodLevels } = usePeriodLevels();
  return useQuery(
    `data-element-${JSON.stringify(id)}-${JSON.stringify(
      ctx.period
    )}-${isDraftFilterAtLocation()}`,
    () => {
      return getValues(
        id || ctx.elementId || "",
        periods.filter((n) => n.name === ctx.period),
        true,
        periodLevels!
      ).then((list) => {
        return resultSort(list);
      });
    },
    {
      enabled: !!periodLevels && !!id && periods?.length > 0,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useElements;
